import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { spacing } = themeVariables;

export const footer = css`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  /* Spaces the price breakdown off the CTA from here, so PriceBreakdown itself
     stays free of any margin belonging to the layout it happens to sit in. */
  gap: var(${spacing.md});
  padding: var(${spacing.md});
  background: var(--neutral-white-base);
  box-shadow: 0 -4px 8px 0 rgba(0, 0, 0, 0.2);
`;

/*
  The Add to Basket CTA and the express wallets share a row, so the sticky footer costs the drawer
  as little height as possible.

  A single wallet sits beside the CTA. Two take the next line instead, which the express block
  asks for by claiming a full basis (see expressCheckout in ExpressCheckout.styles), leaving the
  CTA alone above it to grow to the full width. That split is deliberate rather than measured:
  three buttons abreast leave none of them legible on a phone.

  Beyond that, neither item is given a min-width, so each keeps its own content-based minimum: the
  CTA's label, and the wallets' EXPRESS_WALLET_BUTTON_MIN_WIDTH_PX. That is what still drops a
  lone wallet onto the next line when the CTA beside it is too wide to share, answering to the
  width the drawer has rather than to a breakpoint.
*/
export const ctaRow = css`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(${spacing.sm});
`;

/*
  The CTA's own slot. Each child of the row sets its own flex, rather than a `> *` rule on the row,
  so the express block can still claim a full basis when it holds two wallets.
*/
export const ctaSlot = css`
  flex: 1 1 auto;
`;
